var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color"},_vm._l((_vm.colorBins),function(bin,index){return (bin > 0)?_c('div',{key:index,style:({
			width: _vm.binWidth(bin, _vm.colorTotal),
			background: _vm.colorCode(index)
		})},[_c('div',{staticClass:"preview",style:({ background: _vm.colorCode(index) })}),_c('label',{style:({ color: _vm.textColorCode(index) })},[_vm._v("\n\t\t\t"+_vm._s(_vm.binLabel(bin, _vm.colorTotal))+"\n\t\t")]),_c('span',{staticClass:"count"},[_vm._v("\n\t\t\t"+_vm._s(bin)+"\n\t\t")])]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }